import {Panes, TextField} from '@management-ui/core';
import React from 'react';

const Fields = ({entity = {}, prefix = ''}) => {
  return (
    <Panes
      entity={entity}
      prefix={prefix}
      panes={[
        {
          title: '',
          fields: [
            <TextField
              name="reference"
              prefix={prefix}
              label="Reference"
            />,
          ]
        }
      ]}
    />
  );
};

export default Fields;
